import { Model } from './model';
import { Type } from 'class-transformer';
import { Deduction } from './deduction';
import { Claim } from './claim';
import { Partner } from './partner';
import { Attachment } from './attachment';

export enum DeductionSource {
  EMAIL = 'email',
  UPLOAD = 'upload',
  PORTAL = 'portal',
}

export enum DeductionDocumentType {
  BACKUP = 'backup',
  REMITTANCE = 'remittance',
  MIXED = 'mixed',
  SUPPORT = 'support',
  OTHER = 'other',
}

export enum DeductionDocumentStatus {
  CREATED = 'created',
  UPLOADED = 'uploaded',
  CLASSIFYING = 'classifying',
  PARSING = 'parsing',
  DONE = 'done',
  ERROR = 'error',
}

export class DeductionDocument extends Model {
  id: string;

  download_url: string;

  meta: Record<string, any>;

  status: DeductionDocumentStatus;

  source: DeductionSource;

  type: DeductionDocumentType;

  @Type(() => Attachment)
  attachment: Attachment | null;

  @Type(() => Claim)
  claims: Claim[];

  @Type(() => Deduction)
  deductions: Deduction[];

  @Type(() => Deduction)
  related_deductions: Deduction[];

  @Type(() => Partner)
  partner: Partner | null;

  get canPreview(): boolean {
    return Boolean(this.attachment?.canPreview);
  }
}
